/**
 * Static CSS mesh fallback — replaced WebGL animated mesh from
 * @paper-design/shaders-react with CSS-only gradients.
 *
 * v2: The `.khal-wallpaper.is-mesh` class in khal-wallpaper.css now
 *     handles mesh mode entirely in CSS. This component is a thin
 *     wrapper kept for backward compatibility with the package export.
 *
 * Prefer using the CSS class directly. This component remains as a
 * no-op for consumers that still import it.
 */
export function MeshGradientBackground() {
	return (
		<div
			style={{
				width: '100%',
				height: '100%',
				position: 'absolute',
				inset: 0,
				pointerEvents: 'none',
				background: 'var(--khal-bg)',
			}}
		/>
	);
}
